import { Box, Flex, Group, Paper, Skeleton, Stack, VisuallyHidden } from "@mantine/core";
import { useReducedMotion } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { Shell } from "./Shell";
import { useLayout } from "./useLayout";

export function AppSkeleton() {
  const { t } = useTranslation();
  const layout = useLayout();
  const animate = !useReducedMotion();
  const stacked = layout.phone && !layout.landscape;

  return (
    <Box role="status" aria-busy="true">
      <VisuallyHidden>{t("developmentGate.loading")}</VisuallyHidden>
      <Box aria-hidden="true">
        <Shell>
          <Shell.Header>
            <Group justify="space-between" px={layout.phone ? 12 : 20} pt="headerTop" pb={12}>
              <Skeleton width={160} height={32} animate={animate} />
              <Skeleton width={80} height={32} animate={animate} />
            </Group>
          </Shell.Header>
          <Shell.Main style={{ padding: layout.phone ? "10px 12px" : 20 }}>
            <Flex direction={stacked ? "column" : "row"} gap={layout.phone ? 10 : 16} h="100%">
              <Paper p="sm" flex={1} mih={0} miw={0} style={{ overflow: "hidden" }}>
                <Stack gap="sm">
                  <Skeleton width={90} height={12} animate={animate} />
                  <Skeleton height={32} animate={animate} />
                  <Skeleton width={120} height={12} animate={animate} />
                  {Array.from({ length: 6 }, (_, index) => (
                    <Group key={index} wrap="nowrap" gap={12}>
                      <Skeleton
                        width={48}
                        height={48}
                        style={{ flexShrink: 0 }}
                        animate={animate}
                      />
                      <Stack gap={8} flex={1}>
                        <Skeleton width="75%" height={14} animate={animate} />
                        <Skeleton width="45%" height={12} animate={animate} />
                      </Stack>
                    </Group>
                  ))}
                </Stack>
              </Paper>
              <Paper
                p="sm"
                w={stacked ? "100%" : layout.landscape ? "35%" : "25%"}
                miw={0}
                style={{ flexShrink: 0, overflow: "hidden" }}
              >
                <Stack gap="sm">
                  <Skeleton width={100} height={12} animate={animate} />
                  <Flex direction={layout.phone ? "row" : "column"} gap="sm" align="center">
                    {!layout.landscape && (
                      <Skeleton
                        width={layout.phone ? 48 : "100%"}
                        height={layout.phone ? 48 : undefined}
                        style={{ aspectRatio: "1", flexShrink: 0 }}
                        animate={animate}
                      />
                    )}
                    <Stack gap={8} w="100%">
                      <Skeleton width="80%" height={16} animate={animate} />
                      <Skeleton width="60%" height={12} animate={animate} />
                    </Stack>
                  </Flex>
                  <Group justify="center" gap="sm">
                    <Skeleton width={32} height={32} circle animate={animate} />
                    <Skeleton width={44} height={44} circle animate={animate} />
                    <Skeleton width={32} height={32} circle animate={animate} />
                  </Group>
                </Stack>
              </Paper>
            </Flex>
          </Shell.Main>
          <Shell.Footer>
            <Stack gap={10} p={12}>
              <Skeleton width={180} height={24} animate={animate} />
              <Skeleton height={layout.short ? 64 : 112} animate={animate} />
            </Stack>
          </Shell.Footer>
        </Shell>
      </Box>
    </Box>
  );
}
